export default __webpack_public_path__ + "static/63578-079f0a6d1286f85f27cf3ec6df016c39.jpg";